/** @file SHEET_PLACEHOLDER_IMAGE: the 1 x 1 transparent image a sheet created by drawable.add points at. */

/** Image id of the placeholder sheet image (CR-010); the server stores it before a batch with `drawable.add`. */
export const SHEET_PLACEHOLDER_IMAGE = 'img_0000000000000000000000000Z';
